// extracted by mini-css-extract-plugin
module.exports = {"form":"form--BLvis","division":"division--B96PC","text":"text--X1gTm","line":"line--lYAip"};